// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".book-tabel th>.cell{color:#fff!important}.book-tabel{background-color:#fff}.book-tabel,.book-tabel .el-table__body,.book-tabel tr{border:0!important}.book-tabel td{font-size:14px;font-family:Microsoft YaHei;color:#666;border-bottom:10px solid #f8f8f8!important}", ""]);
// Exports
module.exports = exports;
